import React from 'react';

type OwnProps = {
  className?: string;
};

const LeftArrow = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="14"
    viewBox="0 0 9 14"
    className={className}
  >
    <g>
      <g>
        <path d="M7.79 13.995a1.23 1.23 0 0 1-.79-.32l-6.57-6a1.19 1.19 0 0 1-.43-.91 1.23 1.23 0 0 1 .42-.88L7 .285a1.23 1.23 0 0 1 1.7.12 1.18 1.18 0 0 1-.12 1.69L3 6.825l5.61 5.1a1.18 1.18 0 0 1 .06 1.69 1.2 1.2 0 0 1-.88.38" />
      </g>
    </g>
  </svg>
);

export default LeftArrow;
